import React from 'react';
import { Div, Heading } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';

export interface RotatePhoneProps {
  label: string;
}

export const RotatePhone: React.FC<RotatePhoneProps> = ({ label }) => {
  return (
    <Div display="flex" flexDirection="column" alignItems="center">
      <Div variant="turnPhoneContainer">
        <IconV2 name="rotate-phone" fill="white" width={42} height={42} />
      </Div>
      <Heading variant="H3" as="h3" color="heading" mb={3} textAlign="center">
        {label}
      </Heading>
    </Div>
  );
};
